<template>
  <section class="c-carouselcontainer__container">
    <div class="container">
      <div class="c-carouselcontainer__header">
        <h1 class="c-carouselcontainer__header__title">{{$t('homepage.carousel-container.title')}}</h1>
        <h2
          class="c-carouselcontainer__header__subtitle"
        >{{$t('homepage.carousel-container.first-slide')}}</h2>
      </div>
      <swiper :options="swiperOption" @slideChange="handlePageChange" ref="swiper">
        <!-- <swiper-slide v-if="$mq==='lg' || $mq==='md'" :class="'c-carouselcontainer__firstslide'"> -->
        <swiper-slide :class="'c-carouselcontainer__firstslide'">
          <div class="c-carouselcontainer__firstslide__content">
            <h2
              class="animated faster"
              :class="[this.activePage>0 ? 'fadeOut' : 'fadeIn']"
            >{{$t('homepage.carousel-container.first-slide')}}</h2>
          </div>
        </swiper-slide>
        <template v-for="(slide,index) in catalog">
          <swiper-slide v-bind:key="index">
            <CarouselBox :image="slide.image" :title="slide.title" :cost="slide.cost"></CarouselBox>
          </swiper-slide>
        </template>
      </swiper>
    </div>
  </section>
</template>

<script>
import CarouselBox from "./CarouselBox";

export default {
  props: ["catalog"],
  data() {
    return {
      activePage: 0,
      swiperOption: {
        slidesPerView: 2,
        grabCursor: true,
        watchSlidesProgress: false,
        breakpoints: {
          568: {
            slidesPerView: 1,
            spaceBetween: 30
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 30
          },
          992: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          1200: {
            slidesPerView: 2,
            spaceBetween: 30
          }
        }
      }
    };
  },
  components: {
    CarouselBox
  },
  methods: {
    handlePageChange() {
      this.activePage = this.$refs.swiper.swiper.realIndex;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixins.scss";

.swiper-container {
  overflow: visible;
}

.swiper-slide {
  height: auto;
}

.c-carouselcontainer__container {
  padding-bottom: 4rem;
  overflow: hidden;
}

.c-carouselcontainer__header {
  display: flex;
  flex-direction: column;
  text-align: center;
  @include lg {
    max-width: 60%;
    text-align: left;
  }
  @include xl {
    max-width: 40%;
  }
}

.c-carouselcontainer__firstslide__content {
  margin-top: 2rem;
  padding-right: 1rem;
  color: #a1a1a1;
  h2 {
    @include lg {
      font-size: 30px;
    }
  }
}

.c-carouselcontainer__firstslide {
  display: none;
  @include lg {
    display: block;
  }
}

.c-carouselcontainer__header__title {
  font-size: 34px;
  margin-bottom: 1rem;
  font-weight: 700;
  @include lg {
    font-size: 47px;
  }
}

.c-carouselcontainer__header__subtitle {
  margin-bottom: 2rem;
  color: #a1a1a1;
  letter-spacing: 1px;
  font-size: 24px;
  @include lg {
    display: none;
  }
}
</style>